<footer class="mat-typography">
  <span class="line-1">
    &copy; {{ currentYear }}
    @switch (themeId$ | async) {
      @case (1) {
        <span i18n="@@footerLegal">CenTrak, Inc. All rights reserved.</span>
      }
    }
    {{ currentVersion }}
  </span>
  <ng-template #noDeviceIdTmpl>&nbsp;</ng-template>
  <span *ngIf="deviceID$ | async as data; else noDeviceIdTmpl" class="line-2 unique-identifier-footer">{{data}}</span>
</footer>